import httpClient from 'hub-http/clients/apiClient';
export const fetchScopeStatus = scope => httpClient.get(`/vetting/public/v2/account-verification/state/scope/${scope}`);